<!-- 媒体中心 -->
<template>
  <div class='pgae-media-center'>
    <!-- 头部  -->
    <div class="page_header">
      <span>
        {{$t('mediaCenter.h_t')}}
      </span>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  metaInfo () {
     return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {},
  data () {
    return {
      cultureArr: [],
      pageTitle: '广州市优科易网络科技有限公司-媒體中心',
      metaName:'广州市优科易网络科技有限公司-媒體中心',
      metaContent:'广州市优科易网络科技有限公司-媒體中心',
      keyword:'广州市优科易网络科技有限公司,优科易，网络科技,优科易网络科技',
      description:'广州市优科易网络科技有限公司'
    
    };
  },
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou youkeyi Network Technology Co., Ltd',
        'zh-TCC': '廣州市優科易網絡科技有限公司',
        'zh-CN': '广州市优科易网络科技有限公司'
      }
      this.pageTitle = obj[nval]
    }
  },
  methods: {

  },
  created () {

  },
  mounted () {

  },
}
</script>
<style lang='scss' scoped>
.pgae-media-center {
  width: 100%;
  height: 239px;
  padding-top: 96px;
  padding-left: 31px;
  // background: url('~@/assets/images/notices_bg.png') no-repeat;
  background-size: 100% 100%;
  text-align: left;
  span {
    font-size: 48px;
    font-family: AlibabaPuHuiTi;
    font-weight: bold;
    color: #ffffff;
    text-shadow: 0px 1px 5px rgba(0, 0, 0, 0.26);
  }
}
</style>


// WEBPACK FOOTER //
// src/view/mediaCenter/index.vue